import { number } from "prop-types";
import SparePartRequestCreate from "../../pages/SparePartRequests/SparePartRequestCreate";
import {
  required,
  isEmail,
  isNumber,
  maxLength,
  minLength,
  isAlphabet,
  isPhoneNumber,
  isPassword,
  isChecked,
  isURL,
  isValidDate,
  isValidTime,
  isPath,
  isGST,
  isIconNameOrImage,
  isAlphanumeric,
  isCost,
  radioError,
} from "./Ruls";

export const validate = (formName, formData) => {
  const errors = {};

  const validationRules = {
    EnvironmentCreate: {
      environment: [required, isAlphabet, minLength(3)],
      email: [required, minLength(5), isEmail],
      age: [required, isNumber],
      firstName: [required, minLength(1), maxLength(10)],
      phoneNumber: [isPhoneNumber],
      password: [isPassword],
      is_active: [isChecked],
      active: [isChecked],
      url: [isURL],
      date: [required, isValidDate],
      duration: [isValidTime, required],
      media: [required],
      multiMedia: [required],
      multiModule: {
        type: [required],
        firstName: [required, isAlphabet, minLength(1), maxLength(10)],
        lastName: [required, isAlphabet, minLength(1), maxLength(10)],
        age: [required, isNumber],
      },
      secondMultiModule: {
        type1: [required],
        firstName1: [required, isAlphabet, minLength(1), maxLength(10)],
        lastName1: [required, isAlphabet, minLength(1), maxLength(10)],
        age1: [required, isNumber],
      },
    },
    CountryCreate: {
      country_name: [required, isAlphabet, minLength(3)],
    },
    StateCreate: {
      state_name: [required, isAlphabet, minLength(3)],
      country_id: [required],
    },
    CityCreate: {
      city_name: [required, isAlphabet, minLength(3)],
      // state_id: [required],
      // country_id: [required],
    },
    BranchCreate: {
      branch_name: [required, isAlphabet],
      // city_id: [required],
      // state_id: [required],
      country_id: [required],
      zone_id: [required],
    },
    ItemCreate: {
      gmds_code: [required],
      descriptions: [required],
      category_id: [required],
      uom_id: [required],
      group_id: [required],
      oem_id: [required],
      priority_1_user_id: [required],
    },
    ZoneCreate: {
      zone_name: [required],
    },

    MaterialIntakesCreate: {
      material_id: [required],
      // customer_id: [required],
      scrap_reason_id: [required],
      scrap_remark: [required],
      material_serial_no: [required],
      received_date: [required],
      incoming_invoice_no: [required],
      branch_id: [required],
      is_repairable: [radioError],
      items_matching_invoice: [radioError],
      anti_static_bag: [radioError],
      fault_tag_attached: [radioError],
      fault_reported_from_field: [required],

      rate_per_unit: [required],
    },

    SparePartRequestsCreate: {
      job_card_id: [required],
      spare_id: [required],
      status: [required],
      quantity: [required, isNumber],

      // issue_qty: [required, isNumber],
    },
    ScrapCreate: {
      intake_id: [required],
      scrap_reason_id: [required],
      job_card_no: [required],
      remark: [required],
      // issue_qty: [required, isNumber],
    },

    MaterialApproval: {
      inspected_at: [required],
    },
    SparePartInventoryCreate: {
      material_id: [required],
      quantity: [required, isCost],
      alert_qty: [required, isCost],
    },

    TechnicianInventoryCreate: {
      technician_id: [required],
      material_id: [required],
      quantity: [required, isCost],
    },

    TechnicianStockReturnCreate: {
      return_qty: [required, isCost],
      material_id: [required],
      technician_id: [required],
    },

    WarehouseCreate: {
      project_id: [required],
      state_id: [required],
      city_id: [required],
      warehouse_name: [required],
      type: [required],
    },
    RoleCreate: {
      role_name: [required, isAlphabet],
    },
    OEMCreate: {
      name: [required],
    },
    GroupCreate: {
      name: [required],
    },
    JobCardCreate: {
      technician_check_at: [required],
      // material_id: [required],
      // quantity: [required],
      other_scrap_reason: [required],
      fault_reason_ids: [required],
    },
    UOMCreate: {
      name: [required, isAlphabet],
    },
    CategoryCreate: {
      name: [required],
      material_type: [required, isNumber],
    },
    MenuCreate: {
      menu_name: [required, isAlphabet],
      menu_icon: [isIconNameOrImage],
      menu_url: [required, isPath],
      parent_id: [required],
    },
    ScrapReasonCreate: {
      reason: [required],
    },
    FaultReasonCreate: {
      reason: [required],
    },
    OutgoingInvoicesCreate: {
      branch_id: [required],
      zone_id: [required],
      invoice_number: [required],
      invoice_date: [required],
    },
    CourierCreate: {
      courier_name: [required],
      courier_docket_number: [required],
      courier_docket_date: [required],
    },
    OutgoingViewCreate: {
      courier_name: [required],
      courier_docket_date: [required],
      courier_docket_number: [required],
    },
    UserCreate: {
      // user_type: [required],
      first_name: [required, minLength(3), isAlphabet],
      oem_ids: [required],
      group_ids: [required],
      last_name: [required, minLength(3), isAlphabet],
      role_id: [required],
      email_id: [required, isEmail],
      mobile_number: [required, isPhoneNumber],
      password: [required, minLength(6)],
      username: [required, minLength(3)],

      // alt_mobile_number: [isPhoneNumber],
      // gst_no: [isGST],
      // company_id: [required],
      // subcontractor: {
      //   first_name: [required],
      //   last_name: [required],
      //   email_id: [required, isEmail],
      //   mobile_number: [required, isPhoneNumber],
      //   password: [required, minLength(6)],
      // },
      // user_documents: {
      //   document: [required],
      //   file: [required],
      // },
    },
    InstallationCreate: {
      project_id: [required],
      customer_id: [required],
      order_id: [required],
      form_name: [required],
      ref_document_no: [required, isAlphanumeric],
    },
    StageCreate: {
      stage: [required, isAlphabet],
    },
    GSTPercentageCreate: {
      gst_percentage: [required],
    },
    CommissioningCreate: {
      customer_id: [required],
      form_name: [required, isAlphanumeric],
      ref_document_no: [required, isAlphanumeric],
    },
    ProjectCreate: {
      project_code: [required],
      customer_id: [required],
      project_name: [required],
    },
    SparePartIssuesCreate: {
      issue_qty: [required, isCost],
    },
  };

  const rulesForForm = validationRules[formName];

  if (!rulesForForm) {
    return errors;
  }

  const processValidation = (rules, data, parentKey = "") => {
    for (const field in rules) {
      const fieldRules = rules[field];
      const fieldValue = data[field];
      const fullKey = parentKey ? `${parentKey}.${field}` : field;

      if (Array.isArray(fieldRules)) {
        // Validate flat fields
        for (const rule of fieldRules) {
          const errorMessage = rule(fieldValue, field);
          if (errorMessage) {
            errors[fullKey] = errorMessage;
            break;
          }
        }
      } else if (Array.isArray(fieldValue)) {
        // Special case for arrays like multiModule
        fieldValue.forEach((row, index) => {
          // Process each object in the array
          processValidation(fieldRules, row, `${fullKey}[${index}]`);
        });
      } else if (typeof fieldRules === "object") {
        // Recurse into nested objects
        processValidation(fieldRules, fieldValue || {}, fullKey);
      }
    }
  };

  processValidation(rulesForForm, formData);

  return errors;
};
